<footer class="px-2">
  <ng-content>
    <div></div>
    <div class="small">&copy; {{ currentYear() }}</div>
  </ng-content>
</footer>
